"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _constants = require("../constants");
var _loggerProxy = _interopRequireDefault(require("../common/logs/logger-proxy"));
var _collection = _interopRequireDefault(require("./collection"));
var _request = _interopRequireDefault(require("./request"));
var _util = _interopRequireDefault(require("./util"));
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; } /*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
/**
 * @class MeetingInfo
 */
var MeetingInfo = exports.default = /*#__PURE__*/function () {
  /**
   *
   * @param {WebexSDK} webex
   */
  function MeetingInfo(webex) {
    (0, _classCallCheck2.default)(this, MeetingInfo);
    (0, _defineProperty2.default)(this, "meetingInfoCollection", void 0);
    (0, _defineProperty2.default)(this, "meetingInfoRequest", void 0);
    (0, _defineProperty2.default)(this, "webex", void 0);
    this.webex = webex;

    /**
     * The meeting info request server interface
     * @instance
     * @type {Object}
     * @private
     * @memberof MeetingInfo
     */
    this.meetingInfoRequest = new _request.default(this.webex);
    /**
     * The meeting information collection interface
     * @instance
     * @type {Object}
     * @private
     * @memberof MeetingInfo
     */
    this.meetingInfoCollection = new _collection.default();
  }

  /**
   * @param {string} id
   * @returns {object}
   * @public
   * @memberof MeetingInfo
   */
  (0, _createClass2.default)(MeetingInfo, [{
    key: "getMeetingInfo",
    value: function getMeetingInfo(id) {
      return this.meetingInfoCollection.get(id);
    }

    /**
     * @param {string} id
     * @param {object} info
     * @returns {null}
     * @public
     * @memberof MeetingInfo
     */
  }, {
    key: "setMeetingInfo",
    value: function setMeetingInfo(id, info) {
      this.meetingInfoCollection.set(id, info);
    }

    /**
     * Helper to make the actual MeetingInfo request and set the meetingInfo if successful, else reject
     * @param {Object} options
     * @returns {Promise}
     * @private
     * @memberof MeetingInfo
     */
  }, {
    key: "requestFetchInfo",
    value: function requestFetchInfo(options) {
      var _this = this;
      var meetingId = options.meetingId,
        sendCAevents = options.sendCAevents;
      if (meetingId && sendCAevents) {
        this.webex.internal.newMetrics.submitInternalEvent({
          name: 'internal.client.meetinginfo.request'
        });
        this.webex.internal.newMetrics.submitClientEvent({
          name: 'client.meetinginfo.request',
          options: {
            meetingId: meetingId
          }
        });
      }
      return this.meetingInfoRequest.fetchMeetingInfo(options).then(function (info) {
        if (meetingId && sendCAevents) {
          var _info$body, _info$body2, _info$body3;
          _this.webex.internal.newMetrics.submitInternalEvent({
            name: 'internal.client.meetinginfo.response'
          });
          _this.webex.internal.newMetrics.submitClientEvent({
            name: 'client.meetinginfo.response',
            payload: {
              identifiers: {
                meetingLookupUrl: info === null || info === void 0 ? void 0 : info.url
              }
            },
            options: {
              meetingId: meetingId,
              webexConferenceIdStr: (info === null || info === void 0 ? void 0 : (_info$body = info.body) === null || _info$body === void 0 ? void 0 : _info$body.confIdStr) || (info === null || info === void 0 ? void 0 : (_info$body2 = info.body) === null || _info$body2 === void 0 ? void 0 : _info$body2.confID),
              globalMeetingId: info === null || info === void 0 ? void 0 : (_info$body3 = info.body) === null || _info$body3 === void 0 ? void 0 : _info$body3.meetingId
            }
          });
        }
        if (info && info.body) {
          _this.setMeetingInfo(info.body.sipMeetingUri || info.body.meetingLink, info.body);
        }
        return info;
      }).catch(function (error) {
        _loggerProxy.default.logger.error("Meeting-info:index#requestFetchInfo -->  ".concat(error, " fetch meetingInfo"));
        if (meetingId && sendCAevents) {
          _this.webex.internal.newMetrics.submitInternalEvent({
            name: 'internal.client.meetinginfo.response'
          });
          _this.webex.internal.newMetrics.submitClientEvent({
            name: 'client.meetinginfo.response',
            payload: {
              identifiers: {
                meetingLookupUrl: error === null || error === void 0 ? void 0 : error.url
              }
            },
            options: {
              meetingId: meetingId,
              rawError: error
            }
          });
        }
        return _promise.default.reject(error);
      });
    }

    /**
     * Helper to generate the options for the MeetingInfo request
     * @param {String} destination
     * @param {String} type
     * @returns {Promise}
     * @private
     * @memberof MeetingInfo
     */
  }, {
    key: "fetchInfoOptions",
    value: function fetchInfoOptions(destination, type) {
      return _util.default.generateOptions({
        destination: destination,
        type: type,
        webex: this.webex
      });
    }

    // eslint-disable-next-line valid-jsdoc
    /**
     * Fetches meeting info from the server
     * @param {String} destination one of many different types of destinations to look up info for
     * @param {DESTINATION_TYPE} [type] to match up with the destination value
     * @param {String} [password] meeting password
     * @param {Object} [captchaInfo] captcha code and id
     * @param {String} [installedOrgID]
     * @param {String} [locusId]
     * @param {Object} [extraParams]
     * @param {Boolean} [options] meeting Id and whether Call Analyzer events should be sent
     * @returns {Promise} returns a meeting info object
     * @public
     * @memberof MeetingInfo
     */
  }, {
    key: "fetchMeetingInfo",
    value: function fetchMeetingInfo(destination) {
      var _this2 = this;
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var password = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var captchaInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var installedOrgID = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var locusId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
      var extraParams = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
      var options = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : {};
      if (type === _constants.DESTINATION_TYPE.PERSONAL_ROOM && !destination) {
        destination = this.webex.internal.device.userId;
      }
      return this.fetchInfoOptions(_util.default.extractDestination(destination, type), type).then(function (infoOptions) {
        return (
          // fetch meeting info
          _this2.requestFetchInfo(_objectSpread(_objectSpread({}, infoOptions), options)).catch(function (error) {
            // if it failed the first time as meeting link
            if (infoOptions.type === _constants.DESTINATION_TYPE.MEETING_LINK) {
              // convert the meeting link to sip URI and retry
              return _this2.requestFetchInfo(_objectSpread(_objectSpread({}, _this2.fetchInfoOptions(_util.default.convertLinkToSip(destination), _constants.DESTINATION_TYPE.SIP_URI)), options));
            }
            return _promise.default.reject(error);
          })
        );
      });
    }
  }]);
  return MeetingInfo;
}();
//# sourceMappingURL=index.js.map
